/* 布局 */
//前台
import Layout from "@views/layout";

const smstemplateRouter = {
  path: "/business",
  component: Layout,
  redirect: {
    name: "BUSINESS",
  },
  children: [
    {
      path: "smstemplate",
      name: "SMSTEMPLATE",
      meta: {
        title: "短信模板管理",
        sort: 1,
      },
      component: () => import("@views/business/smstemplate/index.vue"),
      redirect: {
        name: "SMSTEMPLATE_LIST",
      },
      children: [
        {
          path: "list",
          name: "SMSTEMPLATE_LIST",
          meta: {
            title: "短信模板管理",
            sort: 2,
            keepAlive: true,
          },
          component: () => import("@views/business/smstemplate/list.vue"),
        },
        {
          path: "add",
          name: "SMSTEMPLATE_ADD",
          meta: {
            title: "新增短信模板",
            parentPath: "/business/smstemplate/list",
            operate: true,
          },
          component: () => import("@views/business/smstemplate/form.vue"),
        },
        {
          path: "edit",
          name: "SMSTEMPLATE_EDIT",
          meta: {
            title: "编辑短信模板",
            parentPath: "/business/smstemplate/list",
            operate: true,
          },
          component: () => import("@views/business/smstemplate/form.vue"),
        },
      ],
    },
  ],
};

export default smstemplateRouter;
